<div
  class="mtm-user-profile-picture"
  [ngClass]="{ 'square-icon': squareIcon, 'circle-icon': !squareIcon, disabled: disabled }">
  <div
    class="icon-container-color d-flex align-items-center justify-content-center"
    [ngClass]="{ 'show-border': showBorder }">
    <!-- Initials fallback shown while loading or if no picture -->
    @if (!avatarLoaded) {
      <span
        class="icon-color no-select"
        [style.height.px]="height"
        [style.width.px]="width"
        [style.fontSize]="fontSize"
        [style.backgroundColor]="nameColor">
        {{ initialName }}
      </span>
    }
    <!-- Single image element - loads once -->
    @if (hasProfilePicture) {
      <img
        class="icon-avatar"
        [ngClass]="{ 'border-white': showBorder }"
        [class.d-none]="!avatarLoaded"
        [style.height.px]="height"
        [style.width.px]="width"
        [src]="resolvedAvatarUrl"
        (load)="onAvatarLoaded()"
        [alt]="alt"
        (error)="onAvatarError()" />
    }
  </div>
</div>
